import React from "react";
import { Link } from "react-router-dom";
import { Star, Globe, Tv } from "lucide-react";

export default function MovieCard({ item, platformsMap, compact = false }) {
  return (
    <Link
      to={`/title/${item.id}`}
      className="group relative block rounded-md overflow-hidden border border-white/8 bg-obsidian-surface hover:border-amber/40 hover:-translate-y-1 transition-all duration-300"
      data-testid={`movie-card-${item.id}`}
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={item.poster}
          alt={item.title}
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/30 to-transparent" />
        {!compact && (
          <div className="absolute top-3 left-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-black/60 backdrop-blur text-xs text-amber border border-amber/30 font-heading">
            <Star className="h-3 w-3 fill-amber stroke-amber" /> {item.rating}
          </div>
        )}
        {item.has_turkish_dub && (
          <div className="absolute top-3 right-3 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 font-heading">
            TR Dub
          </div>
        )}
      </div>
      <div className={compact ? "p-3" : "p-4"}>
        {!compact && (
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-heading mb-2">
            {item.type === "tv" ? <Tv className="h-3 w-3" /> : <span>•</span>}
            <span>{item.type === "tv" ? "Series" : "Film"}</span>
            <span>·</span>
            <span>{item.year}</span>
          </div>
        )}
        <h3 className={`font-display text-white leading-tight line-clamp-2 ${compact ? "text-base" : "text-xl"}`}>{item.title}</h3>
        {!compact && (
          <>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {item.platforms.slice(0, 4).map((p) => (
                <span
                  key={p}
                  className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded border border-white/10 text-zinc-300 font-heading"
                >
                  {platformsMap?.[p]?.name || p}
                </span>
              ))}
            </div>
            <div className="mt-3 flex items-center gap-1.5 text-xs text-zinc-500">
              <Globe className="h-3 w-3" />
              <span>{item.countries.length} {item.countries.length === 1 ? "country" : "countries"}</span>
            </div>
          </>
        )}
        {compact && (
          <p className="text-xs text-zinc-500 font-heading mt-1">{item.year}</p>
        )}
      </div>
    </Link>
  );
}
